module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figE01_runout-diagram.6d506657.png";